import { gql } from "@apollo/client";
import { TRANSACTION_INFO } from "../fragments";

export const TOPUP = gql`
  mutation topup($input: TopUpInput!) {
    topup(input: $input) {
      ...transactionInfo
    }
  }
  ${TRANSACTION_INFO}
`;

export const WITHDRAW = gql`
  mutation withdraw($input: WithdrawInput!) {
    withdraw(input: $input) {
      id
    }
  }
`;

export const APPROVE_TRANSACTION = gql`
  mutation approveTransaction($transactionId: ID!) {
    approveTransaction(transactionId: $transactionId) {
      ...transactionInfo
    }
  }
  ${TRANSACTION_INFO}
`;

export const CANCEL_TRANSACTION = gql`
  mutation cancelTransaction($transactionId: ID!) {
    cancelTransaction(transactionId: $transactionId) {
      ...transactionInfo
    }
  }
  ${TRANSACTION_INFO}
`;

export const DELETE_TRANSACTION = gql`
  mutation deleteTransaction($id: ID!) {
    deleteTransaction(id: $id) {
      id
    }
  }
`;
